import React from 'react';
import {
  CallAgentModalContainer,
  CallAgentModalImage,
  CallAgentModalOption,
  CallAgentModalTitle,
  ContactNumber,
  ContactText,
} from './CallAgentModal.style';
import WhiteModal from './WhiteModal';

export interface AgentNumber {
  label: string;
  id: string;
  logo?: string;
}

interface CallAgentModalProps {
  onClose: () => void;
  show: boolean;
  items: AgentNumber[];
  onSelected: (a: AgentNumber) => void;
  developer?: boolean;
}

const CallAgentModal: React.FC<CallAgentModalProps> = ({ onClose, show, items, onSelected, developer }) => {
  const multiAgent = items && items.length > 0;
  return (
    <WhiteModal ariaLabel="Call an agent" show={show} onClose={onClose} maxWidth={500}>
      <CallAgentModalContainer multiAgent={multiAgent}>
        <CallAgentModalTitle data-testid="agent-contact-title">
          Call The {developer ? 'Developer' : 'Agent'}
        </CallAgentModalTitle>
        {items &&
          items.map((item) => (
            <CallAgentModalOption key={item.id} data-testid="agent-contact-item">
              {item.logo && (
                <CallAgentModalImage
                  src={item.logo}
                  alt={`${item.label} Logo`}
                  multiAgent={multiAgent}
                  data-testid="agent-contact-logo"
                />
              )}
              <ContactText multiAgent={multiAgent} data-testid="agent-contact-text">
                Call {item.label}
              </ContactText>
              <ContactNumber
                multiAgent={multiAgent}
                data-testid="agent-contact-number"
                href={`tel:${item.id.replace(/\s/g, '')}`}
                onClick={() => onSelected(item)}
              >
                {item.id}
              </ContactNumber>
            </CallAgentModalOption>
          ))}
      </CallAgentModalContainer>
    </WhiteModal>
  );
};

export default CallAgentModal;
